import { Component, OnDestroy, OnInit } from '@angular/core';
import { GenericInputFieldComponent } from '../../../shared/components/generic-input-field/generic-input-field.component';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { GenericService } from '../../../shared/services/generic.services/generic.service';
import { GenericButtonComponent } from '../../../shared/components/generic-button/generic-button.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule, Location } from '@angular/common';
import { ResponseModel } from '../../../shared/models/responseModel';
import { LoginComponent } from '../login/login.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    GenericInputFieldComponent,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    RouterModule,
    CommonModule,
    GenericButtonComponent,
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent implements OnInit {
  public mismatch = true;
  public resetPasswordData: any = null;
  public onDestroy$: Subject<void> = new Subject();

  resetPasswordForm = this.fb.group({
    password: ['', [Validators.required]],
    cPassword: ['', [Validators.required]],
  });

  forgotPasswordForm = this.fb.group({
    email: ['', [Validators.required]],
  });

  constructor(
    private fb: FormBuilder,
    private gen: GenericService,
    private router: Router,
    public authService: AuthService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private location: Location
  ) {
    route.queryParams.subscribe({
      next: (param) => {
        if (Object.keys(param).length > 0) {
          this.resetPasswordData = param;
        }
      },
    });
  }

  ngOnInit(): void {
    this.passwordMatch();
  }

  get fReset() {
    return this.resetPasswordForm.controls;
  }

  get fForgot() {
    return this.forgotPasswordForm.controls;
  }

  passwordMatch() {
    this.resetPasswordForm.get('cPassword')?.valueChanges.subscribe({
      next: (res) => {
        if (res !== this.fReset['password'].value) {
          this.mismatch = true;
          this.fReset['cPassword'].setErrors({ mismatch: this.mismatch });
          console.log(this.resetPasswordForm.get('cPassword')?.errors);
        } else {
          this.mismatch = false;
        }
      },
    });
  }

  forgotPassword(): void {
    this.forgotPasswordForm.markAllAsTouched();
    if (this.forgotPasswordForm.invalid) return;
    this.gen.showLoader('Processing');
    this.authService
      .forgotPassword(this.forgotPasswordForm.value)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (res: ResponseModel) => {
          this.gen.hideLoader();
          if (res.status === 100) {
            this.gen.showMessage('success', res.message);
          } else {
            this.gen.hideLoader();
            this.gen.showMessage('error', res.message);
          }
        },
        error: (err: ResponseModel) => {
          this.gen.hideLoader();
          this.gen.showMessage('error', err.message);
        },
      });
  }

  resetPassword(): void {
    this.resetPasswordForm.markAllAsTouched();
    if (this.resetPasswordForm.invalid) return;
    this.gen.showLoader('Processing');
    let formData = { ...this.resetPasswordForm.value } as any;
    Object.keys(formData).forEach((a) => {
      if (a === 'cPassword') delete formData[a];
    });
    formData.email = this.resetPasswordData['email'];
    formData.token = this.resetPasswordData['token'];
    this.authService
      .resetPassword(formData)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (res: ResponseModel) => {
          this.gen.hideLoader();
          if (res.status === 100) {
            this.gen.showMessage('success', res.message);
            this.openSignUpModal();
            this.back();
          } else {
            this.gen.hideLoader();
            this.gen.showMessage('error', res.message);
          }
        },
        error: (err: ResponseModel) => {
          this.gen.hideLoader();
          this.gen.showMessage('error', err.message);
        },
      });
  }

  openSignUpModal() {
    this.dialog.open(LoginComponent, {
      width: '450px',
      maxHeight: '96%',
      data: '',
      panelClass: 'fullscreen-dialog',
      disableClose: true,
    });
  }

  back() {
    this.router.navigate(['/login']);
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
